import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelEmpty } from '../../../../component/common/designSystem';

/**
 * What the section shows instead of numbers when the cohort is too small.
 *
 * This is a deliberate state, not an error and not an empty one, so it says so
 * plainly. "No data" would be a lie — there is data, and it is being withheld
 * because reporting it would identify people. An admin who sees this and
 * understands why is far less likely to go looking for the same answer
 * somewhere it isn't protected.
 *
 * The exact participant count is not shown, and the backend does not send it:
 * "7 people" in a department of nine is most of the way to a name.
 */
const SuppressedPanel = ({ minimum, what = 'this programme', className = '' }) => (
  <div className={className}>
    <Panel title="Not enough people to report" subtitle="Withheld to protect participants">
      <PanelEmpty>
        Fewer than {minimum} people in the current view are using {what}. Figures stay hidden until
        there are at least {minimum}, so that nothing here can be traced back to an individual —
        being enrolled in a quit programme is health information, and a small group makes an average
        into a personal record.
        <br />
        <br />
        Widening the department filter, or switching between employees and members, may bring enough
        people into view.
      </PanelEmpty>
    </Panel>
  </div>
);

SuppressedPanel.propTypes = {
  minimum: PropTypes.number,
  what: PropTypes.string,
  className: PropTypes.string
};

export default SuppressedPanel;
